/* 国际化 zh */
export default {
  lang: {
    desc: '中文',
  },
  nav: {
    idUpload: '護照上傳',
    pay: '支付',
    protocol: '清扫协议',
    houseState: '房态',
    report: '清扫布草明细',
  },
  guestID: {
    bgDesc: '<p>根据旅馆业法令中有关条例：住宿业者必须核实客人的身份与护照信息是否一致，故请通过如下链接上传入住人本人的 护照首页照片。请您放心，该信息不会出示给相关政府以外的人员</p>',
    refImgDesc: '',
    verifyDesc: '* 请选择以下任意一种身份验证方式完成身份验证<strong>【补全后四位即可】</strong>',
    contactUs: '聯繫我們',
    loadingOrder: '正在載入訂單資訊，請稍等',
    unknownOrder: '無法解析訂單資訊，請檢查你的連結是否正確！',
    concatWay: '<p><strong>緊急聯繫電話:&nbsp;&nbsp;</strong><br><span>+81 645 605 449<br>+86 18918689798<span></p>' +
          '<p><strong>Wechat ID:&nbsp;&nbsp;</strong><br><span>18918689798<span></p>' +
          '<p><strong>WhatsApp ID:&nbsp;&nbsp;</strong><br><span>+8618918689798<span></p>' +
          '<p><strong>Line ID:&nbsp;&nbsp;</strong><br><span>+8618918689798<span></p>' +
          '<p><strong>Email:&nbsp;&nbsp;</strong><br><a href=\'mailto:acehome_customer@zhusu.onmicrosoft.com?subject=Ask help from guest [Identification]\'>acehome_customer@zhusu.onmicrosoft.com<span></p>',
    verifyOrder: { header: '订单号', tip: '请输入订单后四位' },
    verifyPhone: { header: '手机号', tip: '请输入手机号后四位' },
    verifyEmail: { header: '邮箱', tip: '请输入邮箱后四位' },
    verifyStep: ['身份驗證', '上傳證件照', '審核'],
    verifyLast4chars: '后四位字符',
    uploadRule: '图片仅支持.jpg .png .gif 格式，图片大小不大于8M',
    uploadBut: '点击上传',
    uploadStatus: {
      WAIT: '上传成功',
      PASS: '审核通过',
      REJECTED: '审核不通过（请重新上传符合要求的图片）',
    },
    uploadSuccessMsg: '上传成功！我们期待您的到来~',
    nextStep: '下一步',
    agreementDesc: '<h3>本协议内容</h3>' +
      '<p style="margin-bottom: 15px;">本特区度假租赁楼租赁协议（以下简称“协议”） 本公司应与甲方和乙方签订以下合同，内容涉及该物业的特区私人住宿的建筑租赁合同，该合同的签订日期为标注。</p>' +
      '<div><p class="title">临时租赁协议</p><p class="content">根据《土地和房屋租赁法》第 40 条的规定，用户应将标的物业借给甲方用于临时使用，甲方应将其出租。 </p> </div>' +
      '<div><p class="title">有可能的使用</p><p class="content">甲方应将目标物业用于旅游、休闲或其他目的，不得将目标物业用于任何其他目的，包括使用目标物业的业务目的。</p></div>' +
      '<div><p class="title">租金</p><p class="content">本协议项下的租金应按照“租金”栏中的总金额计算，甲方应按照●中规定的方法支付。</p></div>' +
      '<div><p class="title">验证您的身份</p><p class="content">应运营商的要求，甲方在使用符合条件的酒店时应出示护照、驾驶执照或其他带有照片的身份证明文件。 </p></div>' +
      '<div><p class="title">最短租期</p><p class="content">甲方确认标的物业的最短租期为3天（3天2夜），并确认租期不能改为短于最短租期。 即使您搬出不到 3 天，租金也不会退还。 </p></div>' +
      '<div><p class="title">陪同人员</p><p class="content">1. 甲方应将陪同甲方使用目标物业的任何人（以下简称“陪同人员”）通知运营商。 可以保证，在“陪同甲方并使用目标物业的人（陪同人员）”一栏中列出的所有人员。 <br>2. 除“陪同甲方使用目标的物业的人（陪同人员）”一栏所列人员外，甲方不得允许任何人使用目标的物业。<br/>3. 果同伴发生变更，甲方应立即通知运营商，报告运营商要求的事项，并在运营商要求变更后出示同伴的身份验证文件。<br/>4. 甲方应确保随行方遵守与本协议或标的物业的使用有关的甲方义务。</p></div>' +
      '<div><p class="title">甲方应遵守的事项</p><p class="sub-title">甲方不得有下列行为</p><p class="content">1.    《娱乐事业等的规制及业务优化相关法律》第2条第1项（第5项中事先征得用户同意的除外） 将标的物业用于同一法律第2条第5款所定义的娱乐业务。<br/>2.    处理、掩埋、储存、净化、运输、加工、制造、生成、释放、倾倒、转移、或将标的物业用于其他处置或处理;<br/>3.    对暴力要求、超出法律责任的不合理要求或交易进行威胁性言语或行动;或使用暴力、散布谣言、使用欺诈手段或使用武力保护您或物业所有者三菱UFJ信托银行株式会社（以下简称“所有者”）的行为。 ）损害公信力或干扰用户或所有者的业务。</p></div>' +
      '<div><p class="title">要确认事项</p><p class="sub-title">1.    甲方应确认并遵守以下各项规定的事项。</p><p class="content">(1)    甲方与乙方之间的合同属于转租，转租合同项下的义务（保证金返还义务（如有）包含。由用户全权负责;船东对甲方不承担任何义务。<br/>(2)    甲个是、请勿将租赁权转租或转让给第三方。<br/>(3)    甲方和随行方应事先同意用户向所有者披露地址和姓名等个人信息。<br/></p><p class="sub-title">2.    甲方应告知乙方，甲方及其陪同人员应为反社会势力（第（1）项所列人员）。 这同样适用于下文。 以及与反社会势力有关系或参与的事实（包括但不限于第（2）项所列情况）。 保证没有。</p><p class="content">(1)反社会势力1 有组织犯罪集团、有组织犯罪集团成员或类似人员<br/>2 根据《不分青红皂白的大规模杀戮组织管理法》受到惩罚的人<br/>3 根据《惩治有组织犯罪法》和《犯罪收益管理法》等规定，涉嫌隐瞒或收受犯罪所得的人。<br/>4 《放债业务法》第24条第3款规定的收款限制人员<br/>5 经营违反公共利益并受到社会批评的人<br/>6 威胁民间社会秩序和安全，阻碍健全的经济活动和社会发展的人<br/>(2)    与反社会势力的关系或参与反社会势力的事实<br/>1 与甲方（包括甲方及其高级职员（如果公司是公司）、其关联公司及其高级职员等）相关的人员。 这同样适用于下文。 是有组织犯罪集团等反社会势力。<br/>2 有组织犯罪集团等反社会势力参与与公司有关的各方的管理。<br/>3 甲方的有关人员通过向有组织犯罪集团等反社会势力提供资金或其他行为，与有组织犯罪集团等反社会势力合作或参与维持或运作。<br/>4 甲方当事人曾与有组织犯罪集团等反社会势力交往。<br/>5 允许反社会势力使用您的姓名缔结本协议。<br/>6 将目标物业作为反社会势力的办公室或其他活动基地。</p></div>' +
      '<div><p class="title">运营者的介入</p><p class="content">即使在租赁期内，当目标物业的卫生管理或目标物业的其他管理特别需要时，运营商也可以在甲方事先同意的情况下进入目标物业。 </p></div><div><p class="title">使用设施时要记住的要点，每个设施可以提供的服务</p><div class="content">入住该设施的客人在使用该设施时应注意以下事项。<br/>1 如何使用设施中提供的设施<br/>2 垃圾处理方法<br/>3 请勿因噪音等而打扰他人。<br/>4 在发生火灾等紧急情况时，在哪里联系以及如何最初应对<br/>5、需要对目标物业进行卫生管理或其他管理时，应事先征得住户同意，并放置在目标物业内。 <br/>详情见附件（房屋须知）。 甲方应确认运营商的解释。<br/></div></div>' +
      '<div><p class="title">取消等</p><p class="content">如果甲方或随行方有下列任何原因，用户可以立即终止本协议，以期将来不另行通知。 <br/>(1)    如果枪支、剑或具有挥发弹性或易燃性的危险物品被制造或储存在目标物业中。<br/>(2)    如果您在目标物业携带大型保险箱或其他重物<br/>(3)    如果液体可能腐蚀目标属性中的排水管<br/>(4)    如果孩子在主题物业中以高音量播放电视、立体声音响等，或弹钢琴等。<br/>(5)    在目标物业中饲养明显给邻里带来麻烦的动物时，例如凶猛的野兽和毒蛇<br/>(6)    如果标的物业被用作反社会势力的办公室或其他活动基地<br/>(7)    如果标的物业或目标物业附近通过说或做极其粗鲁或暴力的言语或行为，或表现出虚张声势，引起公民或路人的焦虑。<br/>(8)    如果反社会势力居住在目标物业中，或者如果反社会势力反复和连续地进出该物业。<br/>(9)    违反本协议或运营商规定的目标物业使用规则时<br/></p></div>' +
      '<div><p class="title">损害赔偿</p><p class="content">除本协议另有规定外，本协议各方仅对因本协议而给另一方造成的损害承担直接损失的普通损害赔偿责任。</p></div>' +
      '<div><p class="title">准据法及司法管辖权</p><p class="content">本协议受日本法律管辖并按日本法律解释，与本协议有关的任何争议均应受作为一审法院的大阪地方法院的专属管辖。<br/>以上</p></div>',
    address: '地址',
    name: '姓名',
    phone: '电话',
    nationality: '国籍',
    passportNumber: '护照号码',
    viewExample: '查看示例',
    addGuest: '增加入住人',
    confirm: '确认并提交',
    corporationName: '公司名',
    corporationAddress: '公司地址',
    representativeDirector: '公司法人',
    invoiceIssuerNumber: '适格请求书发行事业者编号',
    Lessor: '出租方（乙方）',
    Lessee: '承租方（甲方）',
    expand: '展开',
    collapse: '收起',
    specialTitle: '特区度假租赁大楼租赁协议',
    leaseInformation: '租赁信息',
    propertyName: '物业名',
    leasePeriod: '租借期间',
    rent: '租金',
    leaseExecutionDate: '签署日期',
    facilityUsagefee: '设施使用费',
    cleaningFee: '清洁费',
    total: '合计',
    photo: '护照照片',
    taxIncluded: '（含税）',
    uploadPassport: '上传护照',
    confirmTip: '请将信息填写完整',
    notPassport: '不是护照',
    imgNOtClear: '图片不清晰',
  },
  payment: {
    stepOne: '核对信息',
    stepTwo: '填写信用卡',
    stepThree: 'stripe官方付款验证',
    stepFour: '完成',
    orderConfirmNo: '订单确认号',
    customerInfo: '客户信息',
    name: '姓名',
    email: '邮箱',
    paymentInfo: '支付信息',
    orderPrice: '房费',
    cleanFee: '清扫费',
    deposit: '其他',
    totalAmount: '总价',
    status: '状态',
    notPayStatus: '待支付',
    successPayStatus: '支付成功',
    failPayStatus: '支付失败',
    refundPayStatus: '退款',
    payWay: '支付方式',
    payAttention: '本页只支持stripe支付方式，我们正在添加其他的支付方式，请理解。',
    receiptEmail: '邮箱',
    receiptEmailContent: '接收支付成功收据的邮箱地址',
    creditCard: '信用卡',
    depositDesc: '押金说明：请保护好房间里的设施，您将在退房后7天内收到全额退款，若有任何损失或损坏，将要赔偿。',
    submitText: '提交支付',
    payAgain: '重新支付',
    pay: '付款',
  },
  upload: {
    clickUploadFile: '点击上传文件',
    uploadDefaultDesc: '最大可以上传10MB的附件，如果文件过大，请压缩后上传',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    uploadFormatWarning: '上传内容格式必须为',
    uploadSizeWarning: '上传内容大小不能超过',
    duplicateWarning: '不能上传重复的文件名',
    cancelUpload: '取消上传',
  },
}
